import { Component, OnInit } from '@angular/core';
import {LandingPricingService} from '../landing-pricing.service';
import { AppConfigService } from '../../../services/app-config.service';
import { countries } from 'countries-list';

@Component({
  selector: 'landing-pricing-section',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  prices = [];
  activePriceIndex = 0;
  activeBindingIndex = 0;
  // bindings = [
  //   {
  //     title: 'SEAMLESS LAYFLAT',
  //     priceIndex: 'seamlessPrice',
  //     image: require('./assets/seamless.png'),
  //   }
  // ];

  constructor(
    public pricingService: LandingPricingService,
    private appConfigService: AppConfigService,
    ) {
    this.prices = this.pricingService.getUs();
  }

  ngOnInit() {
    this.appConfigService.configSubject.subscribe(config => {
      if (config.geo_info) {
        if (config.geo_info.country_code === 'CH') {
          this.prices = this.pricingService.getCh();
        } else {
          this.prices = this.pricingService.getUs();
        }
      }
    });
  }

  activatePrice(i) {
    this.activePriceIndex = i;
  }

  activateBinding(i) {
    this.activeBindingIndex = i;
  }

}
